import {
  Component,
} from '@angular/core';
import { FormControl } from '@angular/forms';
import { Store } from '@ngrx/store';
import { selectCurrentSite } from '../../../../features/site/site.selectors';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Site } from '../../../../models/site';
import { InspectionModule } from '../../../../enums/inspection-module';
import { ViewRepresentation } from '../../../../enums/representation';
import {
  setConfigViewRepresentation
} from '../../../../features/config/config.actions';
import { Batch } from '../../../../models/batch';
import { selectAllBatchs } from '../../../../features/batch/batch.selectors';
import {
  selectConfigViewRepresentation, selectSplittedTilesetIsLoading,
  selectTilesetIsLoading
} from '../../../../features/config/config.selectors';
import { Actions, ofType } from '@ngrx/effects';
import {
  addTilesetConfig, addTilesetConfigFailure, addTilesetConfigSuccess
} from '../../../../features/tileset-config/tileset-config.actions';
import { MatSelect } from '@angular/material/select';


@Component({
    selector: 'view-representation-selector',
    templateUrl: './view-representation-selector.component.html',
    styleUrls: ['./view-representation-selector.component.scss'],
    standalone: false
})
export class ViewRepresentationSelectorComponent {

  batchs: Array<Batch> = [];
  viewRepresentation = ViewRepresentation;
  inspectionModule = InspectionModule;
  representationControl = new FormControl(ViewRepresentation.TEXTURED);
  tilesetConfigComputing: boolean = false;

  readonly selectedSite$ = this.store.select(selectCurrentSite);
  readonly isTilesetLoading$ = this.store.select(selectTilesetIsLoading);
  readonly isSplittedTilesetLoading$ = this.store.select(selectSplittedTilesetIsLoading);

  constructor(private store: Store, private actions: Actions) {
    this.initHandleConfig();
    this.initHandleBatch();
  }

  private initHandleConfig(): void {
    this.store.select(selectConfigViewRepresentation)
      .pipe(takeUntilDestroyed())
      .subscribe((viewRepresentation) => {
        if (viewRepresentation != this.representationControl.value) {
          this.representationControl.setValue(viewRepresentation);
        }
      });
  }

  private initHandleBatch(): void {
    this.store.select(selectAllBatchs)
      .pipe(takeUntilDestroyed())
      .subscribe((batchs: Array<Batch> | null | undefined) => {
          this.batchs = (batchs) ? batchs : [];
      });
  }

  onChangeRepresentation(event: any, matSelect: MatSelect): void {
    this.store.dispatch(setConfigViewRepresentation({value: event.value}));
    matSelect.close();
  }

}
